import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { TableComponent } from '@markant-platform/shared/table/feature';
import { notBlank } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-audit-reason-dialog',
  templateUrl: './audit-reason.component.html',
  styleUrls: ['./audit-reason.component.scss'],
  standalone: true,
  imports: [
    MarkantElementsModule,
    ReactiveFormsModule,
    FormControlKeyErrorPipe,
    FormControlErrorPipe,
    TranslocoPipe,
    TableComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditReasonDialogComponent {
  @Output() closed = new EventEmitter<void>();
  @Output() saveChanges = new EventEmitter<string>();

  reason = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(60), notBlank],
  });

  save(): void {
    if (this.reason.valid) {
      this.saveChanges.emit(this.reason.value);
    }
  }

  closeDialog(): void {
    this.closed.emit();
  }
}
